class MyCompanyChangedListenerService {

    listeners: Array<(() => void)> = [];

    public registerListener(cb: () => void) {
        this.listeners.push(cb);
    }

    public notifyMyCompanyChanged() {
        const eventListeners = this.listeners;
        if (eventListeners) {
            for (const eventListenerCB of eventListeners) {
                eventListenerCB();
            }
        }
    }

}

const MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE = new MyCompanyChangedListenerService();

export {MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE};
